'use client';

import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';

import { cn } from '@playbooks/ui/lib/utils';

function Separator({ className, orientation = 'horizontal', ...props }: SeparatorPrimitive.Props) {
	// Theme
	const rootClassName = cn(
		'shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch',
		className,
	);

	// Render
	return <SeparatorPrimitive data-slot='separator' orientation={orientation} className={rootClassName} {...props} />;
}

export { Separator };
